import { PageLayout } from '@/pages/PageLayout';

const H2 = ({ children }) => (
  <h2 className="text-xl font-semibold text-slate-900 dark:text-white pt-2">{children}</h2>
);

export function PrivacyPolicy() {
  return (
    <PageLayout title="Privacy Policy">
      <p>
        AssistlyAI (&quot;we&quot;, &quot;us&quot;) provides an AI assistant you interact with through
        WhatsApp. This policy explains what we collect, why we collect it, and your choices.
      </p>

      <div className="space-y-4">
        <H2>Information you share with us</H2>
        <p>
          When you message AssistlyAI on WhatsApp, we process the content of those messages so the
          assistant can respond — for example scheduling meetings, setting reminders, summarising
          notes, or answering questions about documents or images you choose to send (such as
          tickets or PDFs).
        </p>
        <p>
          We may also process technical data needed to run the service (for example timestamps,
          message delivery status, and diagnostic logs) in line with this policy.
        </p>
      </div>

      <div className="space-y-4">
        <H2>How we use your information</H2>
        <ul className="list-disc pl-5 space-y-2">
          <li>To provide, maintain, and improve AssistlyAI features you use.</li>
          <li>To keep your account and conversations secure and prevent abuse.</li>
          <li>To communicate with you about the service, billing, or support when needed.</li>
          <li>To comply with applicable law and respond to lawful requests.</li>
        </ul>
      </div>

      <div className="space-y-4">
        <H2>WhatsApp and third parties</H2>
        <p>
          Your use of WhatsApp is also subject to Meta&apos;s terms and privacy practices. We do not
          control how WhatsApp processes data on its platform; we only receive what is necessary to
          operate AssistlyAI for you.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Retention</H2>
        <p>
          We retain information only as long as needed to provide the service, meet legal
          obligations, resolve disputes, and enforce our agreements. Retention periods may vary by
          type of data and how you use the product.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Security</H2>
        <p>
          We use appropriate technical and organisational measures to protect your information. No
          method of transmission over the internet is 100% secure; we encourage you not to share
          sensitive credentials or data you are not comfortable sending via chat.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Your rights</H2>
        <p>
          Depending on where you live, you may have rights to access, correct, delete, or restrict
          processing of your personal data, or to object to certain processing. Contact us (see
          Contact on this site or WhatsApp support) to make a request. We will respond in line with
          applicable law.
        </p>
      </div>

      <div className="space-y-4">
        <H2>Changes</H2>
        <p>
          We may update this policy from time to time. We will post the updated version on this page
          and adjust the &quot;Last updated&quot; date above.
        </p>
      </div>
    </PageLayout>
  );
}
